import type { TranslationKey } from "./en";

export const sv: Record<TranslationKey, string> = {
  appName: "Rikskurs",
  tagline: "Riksbankens räntor och valutakurser, utforskade",
  "nav.language": "Språk",
  "nav.theme": "Byt tema",
  "category.currency": "Valuta",
  "category.interest": "Ränta",
  "category.index": "Index",
  "picker.series": "Välj serie",
  "picker.from": "Från",
  "picker.to": "Till",
  "picker.apply": "Visa",
  "chart.value": "Värde",
  "chart.date": "Datum",
  "table.date": "Datum",
  "table.value": "Värde",
  "table.change": "Förändring",
  "unit.sekPerUnit": "SEK per {currency}",
  "unit.percent": "Procent",
  "unit.indexPoints": "Indexpoäng",
  "state.loading": "Hämtar data…",
  "state.empty": "Ingen data finns ännu för den här perioden. Riksbanken publicerar normalt nya siffror nästa bankdag.",
  "state.error": "Kunde inte nå Riksbankens datatjänst. Försök igen om en stund.",
  "state.retry": "Försök igen",
  "footer.source": "Data från Riksbankens API",
  "series.repoRate": "Reporänta",
  "series.depositRate": "Inlåningsränta",
  "series.lendingRate": "Utlåningsränta",
  "series.fineTuningRate": "Finjusteringsränta",
  "series.referenceRate": "Referensränta",
  "series.stiborTN": "STIBOR Tomorrow/Next",
  "series.kixIndex": "KIX (kronindex)",
  "series.tcwIndex": "TCW-index",
  "readout.latest": "Senaste värde",
  "readout.asOf": "Per {date}",
  "readout.noData": "Inget värde för perioden",
  "table.noChange": "Ingen föregående punkt",
  "table.empty": "Inga rader att visa.",
  "errorBoundary.title": "Något gick fel",
  "errorBoundary.message": "Ett oväntat fel inträffade. Ladda om sidan för att fortsätta.",
  "errorBoundary.reload": "Ladda om",
};
